// config.js

const bizIcon = 'https://images.marketleader.com/Logos/44/920444_normal.png';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://images.marketleader.com/mastheads/catalog/ML-masthead-Light_644446420_f.jpg";
const imageTwo = "https://images.marketleader.com/HouseImages/NORTHCENTRALMS/846/158846.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageThree = "https://images.marketleader.com/HouseImages/NORTHCENTRALMS/506/159506.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageFour = "https://images.marketleader.com/HouseImages/NORTHCENTRALMS/676/159676.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageFive = "https://images.marketleader.com/MarketingImages/91/2404091_normal.jpg";

const redirectLink = "https://theskybluepaintingllc.com/";

export const siteConfig = {
  title: "Fergie Crill | Re/Max Legacy",
  metaDescription: "Fergie Crill | Re/Max Legacy",
  theme: {
    primaryColor: "red-600",
    secondaryColor: "gray-900",
    accentColor: "text-red-600"
  },
  logo: {
    src: bizIcon,
    alt: "Fergie Crill | Re/Max Legacy Icon",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Fergie Crill | Re/Max Legacy",
    headline: "Helping You Find Your Dream Home in Oxford, MS",
    address: "Galleria Ln, Oxford, MS",
    description: `
        Fergie Crill is a dedicated realtor with Re/Max Legacy, specializing in helping clients buy and sell properties in Oxford, MS, and surrounding areas. With a passion for providing exceptional service, Fergie focuses on understanding her clients' unique needs and delivering results that exceed expectations. Whether you're a first-time homebuyer, looking for your next investment property, or selling your current home, Fergie offers personalized guidance and expert market insights every step of the way. Trust Fergie Crill to make your real estate journey smooth, successful, and stress-free.
    `,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Helping You Find Your Dream Home in Oxford, MS",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
          "Local Expertise: With in-depth knowledge of Oxford, MS, and its surrounding communities, I help you find the perfect home at the right price, complete with the neighborhood amenities that matter most to you.",
    },
    {
        description: 
          "Selling Your Home: From marketing and finding the right buyer to negotiating, overseeing inspections, and handling paperwork, I take care of everything you need to ensure a smooth and successful sale.",
    },
    {
        description: 
          "Timing Is Everything: Whether you're buying or selling, I provide expert guidance and advice to help you make the best decisions for your real estate journey. Let’s work together to achieve your goals today!",
    },
  ],
  services: {
    sectionTitle: "Our Active Communities Serviced",
    description: 
      "As a trusted real estate professional, I proudly serve a variety of communities in and around Oxford, MS. Whether you're searching for your dream home or looking to sell, I am committed to providing exceptional service and expertise tailored to your unique needs. Explore the communities I serve and discover what makes each location special.",
    callouts: [
        {
          name: 'Bruce | 207-209 HWY 32 E, BRUCE, MS, 38915',
          description: 
            "Discover the charm of Bruce, MS. With its welcoming community and beautiful properties, Bruce is an ideal location for those seeking a quiet, friendly atmosphere with easy access to essential amenities.",
          imageSrc: imageTwo,
          imageAlt: 'A scenic view of a residential property in Bruce, MS.',
        },
        {
          name: 'Oxford | 1021 Scarlett Dr, OXFORD, MS, 38655',
          description: 
            "Experience the vibrancy of Oxford, MS, a city that blends southern charm with modern living. From its thriving culture to its picturesque neighborhoods, Oxford offers something for everyone.",
          imageSrc: imageThree,
          imageAlt: 'A well-maintained home in the heart of Oxford, MS.',
        },
        {
          name: 'Oxford | TBD Cr 202, OXFORD, MS, 38655',
          description: 
            "Explore this serene area in Oxford, MS, where you'll find spacious properties surrounded by natural beauty. Perfect for those seeking tranquility and a close-knit community feel.",
          imageSrc: imageFour,
          imageAlt: 'A peaceful residential area in Oxford, MS, surrounded by greenery.',
        },
    ]
  },
  about: {
    sectionTitle: "About Us",
    description:   
      "Welcome to Fergie Crill | Re/Max Legacy, where I bring a wealth of knowledge and expertise to guide you through every step of your real estate journey. Based in Oxford, MS, I am passionate about connecting clients with their dream homes and helping sellers achieve their goals. With a deep understanding of local communities, current market trends, and the complexities of the buying and selling process, I strive to deliver an experience that exceeds expectations. \n\nWhether you're searching for the perfect neighborhood amenities, selling your home, or need guidance on inspections and paperwork, I am here to handle every detail with care and professionalism. Timing is everything in real estate, and I am dedicated to helping you make informed decisions for the best possible outcomes. Let’s work together to turn your real estate goals into reality!",
    image: {
      src: imageFive,
      alt: "Fergie Crill providing exceptional real estate services in Oxford, MS.",
      width: 1200,
      height: 800,
    },
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Galleria Ln, Oxford, MS, USA",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.052398477527!2d-89.55115938479608!3d34.36649518052079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8880c773bc06a0d5%3A0xabcdef123456789!2sGalleria%20Ln%2C%20Oxford%2C%20MS%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=Galleria+Ln,+Oxford,+MS,+USA',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=Galleria+Ln,+Oxford,+MS,+USA&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/Galleria+Ln,+Oxford,+MS,+USA/@34.366495,-89.551159,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/Galleria+Ln,+Oxford,+MS,+USA/@34.366495,-89.551159,15z',
      },
    ],  
  },
  contact: {
    sectionTitle: "Get in Touch with Fergie Crill | Re/Max Legacy",
    description: 
      "Whether you're buying your first home, selling a property, or searching for your dream home in Oxford, MS, and surrounding areas, Fergie Crill is here to guide you every step of the way. With deep local expertise and a commitment to exceeding your expectations, Fergie ensures a seamless and successful real estate experience. Contact her today for personalized service and expert advice to make your real estate goals a reality!",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (662)-234-5621",
      "Cellular: (662)-202-2652",
    ],
    logo: bizIcon,
    emailRecipient: "fergiecrill@gmail.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


